<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4">
            <router-link to="/liste-support" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative">Retour</span>
            </router-link>
            <h4 class="mb-0">Détails du support de cours</h4>
          </div>

          <div class="row mb-4">
            <div class="col-md-6">
              <div class="info-card p-3 border rounded bg-light">
                <h6 class="text-primary mb-3">
                  <i class="flaticon-book me-2"></i>Informations générales
                </h6>
                <div class="row mb-2">
                  <div class="col-5"><strong>Titre :</strong></div>
                  <div class="col-7">{{ supportCours?.titre || 'Aucun titre' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Description :</strong></div>
                  <div class="col-7">{{ supportCours?.description || 'Aucune description' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Auteur :</strong></div>
                  <div class="col-7">{{ supportCours?.auteur || 'Aucun Auteur' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Nombre d'heures :</strong></div>
                  <div class="col-7">{{ supportCours?.nombreHeures || 0 }} h</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Nombre de modules :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-success">{{ supportCours?.modules?.length || 0 }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Prérequis :</strong></div>
                  <div class="col-7">{{ supportCours?.prerequis || 'Aucun' }}</div>
                </div>
                
                <div class="row mb-2">
                  <div class="col-5"><strong>Fichier principal :</strong></div>
                  <div class="col-7">
                    <div v-if="supportCours?.fichier" class="d-flex flex-column gap-2">
                      <div class="file-name-display mb-2">
                        <i class="flaticon-file me-2 text-danger"></i>
                        <small class="text-muted">{{ supportCours.fichier }}</small>
                      </div>
                      <div class="d-flex gap-2">
                        <button 
                          @click="viewSupportFile(supportCours.id)"
                          class="btn btn-sm btn-outline-primary"
                        >
                          <i class="flaticon-eye me-1"></i>Voir
                        </button>
                        <button 
                          @click="downloadSupportFile(supportCours.id, supportCours.titre)" 
                          class="btn btn-sm btn-outline-success"
                        >
                          <i class="flaticon-download me-1"></i>Télécharger
                        </button>
                      </div>
                    </div>
                    <span v-else class="text-muted">Aucun fichier</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="info-card p-3 border rounded bg-light">
                <h6 class="text-primary mb-3">
                  <i class="flaticon-layers me-2"></i>Filière / Niveau / Matière
                </h6>
                <div class="row mb-2">
                  <div class="col-5"><strong>Filière :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-info">
                      {{ supportCours?.filiereNiveauMatiere?.filiere?.libelle || 'N/A' }}
                    </span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Niveau :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-warning">
                      {{ supportCours?.filiereNiveauMatiere?.niveau?.libelle || 'N/A' }}
                    </span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Matière :</strong></div>
                  <div class="col-7">
                    <span class="badge bg-primary">
                      {{ supportCours?.filiereNiveauMatiere?.matiere?.libelle || 'N/A' }}
                    </span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-5"><strong>Date de création :</strong></div>
                  <div class="col-7">
                    {{ formatDate(supportCours?.createdAt) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h5 class="text-primary mb-3 border-bottom pb-2">
                <i class="flaticon-book me-2"></i>Liste des modules ({{ supportCours?.modules?.length || 0 }})
              </h5>

              <div v-if="supportCours?.modules && supportCours.modules.length > 0">
                <div
                  v-for="(module, index) in supportCours.modules"
                  :key="module.id"
                  class="cours-card border rounded p-3 mb-3 shadow-sm bg-white"
                >
                  <div class="cours-header bg-primary text-white p-2 rounded mb-3">
                    <h6 class="mb-0">
                      <i class="flaticon-book me-2"></i>Module {{ index + 1 }} : {{ module.titre }}
                    </h6>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Code</small>
                        <strong>{{ module.code || 'Sans code' }}</strong>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Titre</small>
                        <strong>{{ module.titre || 'Aucun titre' }}</strong>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Description</small>
                        <strong>{{ module.description || 'Aucune description' }}</strong>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="info-item mb-2">
                        <small class="text-muted d-block">Fichier du module</small>
                        <div v-if="module.fichier" class="mt-2">
                          <div class="file-name-display mb-2">
                            <i class="flaticon-file me-1 text-danger"></i>
                            <small class="text-muted">{{ module.fichier }}</small>
                          </div>
                          <div class="d-flex gap-2">
                            <button 
                              @click="viewModuleFile(module.id)"
                              class="btn btn-sm btn-outline-primary"
                            >
                              <i class="flaticon-eye me-1"></i>Voir
                            </button>
                            <button 
                              @click="downloadModuleFile(module.id, module.titre || module.code)" 
                              class="btn btn-sm btn-outline-success"
                            >
                              <i class="flaticon-download me-1"></i>Télécharger
                            </button>
                          </div>
                        </div>
                        <span v-else class="text-muted">Aucun fichier</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="alert alert-info">
                <i class="flaticon-info me-2"></i>
                Aucun module trouvé pour ce support de cours.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal PDF -->
    <div 
      v-if="showPdfModal" 
      class="modal fade show d-block pdf-modal-overlay" 
      tabindex="-1" 
      @click.self="closePdfModal"
    >
      <div class="modal-dialog modal-xl modal-dialog-top">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="flaticon-file me-2"></i>{{ currentPdfTitle }}
            </h5>
            <button 
              type="button" 
              class="btn-close btn-close-white" 
              @click="closePdfModal"
            ></button>
          </div>
          <div class="modal-body p-0 pdf-viewer-container">
            <iframe 
              v-if="currentPdfBlob"
              :src="currentPdfBlob" 
              class="pdf-viewer-iframe"
              title="Visualiseur PDF"
            ></iframe>
            <div v-else class="d-flex justify-content-center align-items-center" style="height: 80vh;">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Chargement...</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-secondary" 
              @click="closePdfModal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";
import { error, success } from "@/utils/utils";

export default defineComponent({
  name: "ViewSupportCours",
  setup() {
    const route = useRoute();
    const supportCours = ref<any>(null);
    const showPdfModal = ref(false);
    const currentPdfBlob = ref('');
    const currentPdfTitle = ref('');

    const getSupportCours = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/supports/${id}`);
        supportCours.value = data.data;
        console.log(" Support de cours chargé:", data.data);
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement du support de cours");
        console.error(" Erreur:", err);
      }
    };

    const viewSupportFile = async (supportId: number) => {
      try {
        currentPdfTitle.value = 'Support de cours';
        showPdfModal.value = true;
        
        const response = await ApiService.get(`/supports/${supportId}/download`, { 
          responseType: 'blob' 
        });
        
        const blob = new Blob([response.data], { type: 'application/pdf' });
        currentPdfBlob.value = window.URL.createObjectURL(blob);
        
        document.body.style.overflow = 'hidden';
      } catch (err: any) {
        console.error("❌ Erreur visualisation:", err);
        error("Impossible de visualiser le fichier");
        closePdfModal();
      }
    };

    // ✅ Voir le fichier du module dans le modal
    const viewModuleFile = async (moduleId: number) => {
      try {
        currentPdfTitle.value = 'Module';
        showPdfModal.value = true;
        
        const response = await ApiService.get(`/supports/modules/${moduleId}/download`, { 
          responseType: 'blob' 
        });
        
        const blob = new Blob([response.data], { type: 'application/pdf' });
        currentPdfBlob.value = window.URL.createObjectURL(blob);
        
        document.body.style.overflow = 'hidden';
      } catch (err: any) {
        console.error("❌ Erreur visualisation module:", err);
        error("Impossible de visualiser le module");
        closePdfModal();
      }
    };

    const closePdfModal = () => {
      showPdfModal.value = false;
      if (currentPdfBlob.value) {
        window.URL.revokeObjectURL(currentPdfBlob.value);
      }
      currentPdfBlob.value = '';
      currentPdfTitle.value = '';
      document.body.style.overflow = '';
    };

    // ✅ Téléchargement du support
    const downloadSupportFile = async (supportId: number, titre: string) => {
      try {
        const response = await ApiService.get(`/supports/${supportId}/download`, { 
          responseType: 'blob' 
        });
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${titre.replace(/[^a-z0-9]/gi, '_') || 'support'}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        success("Support téléchargé avec succès !");
      } catch (err: any) {
        console.error("❌ Erreur téléchargement:", err);
        error("Fichier non disponible ou erreur de téléchargement");
      }
    };

    // ✅ Téléchargement du module
    const downloadModuleFile = async (moduleId: number, titre: string) => {
      try {
        const response = await ApiService.get(`/supports/modules/${moduleId}/download`, { 
          responseType: 'blob' 
        });
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${titre.replace(/[^a-z0-9]/gi, '_') || 'module'}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        success("Module téléchargé avec succès !");
      } catch (err: any) {
        console.error("❌ Erreur téléchargement module:", err);
        error("Module non disponible");
      }
    };

    const formatDate = (date: string) => {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getSupportCours(id);
      }
    });

    return { 
      supportCours,
      showPdfModal,
      currentPdfBlob,
      currentPdfTitle,
      viewSupportFile,
      viewModuleFile,
      closePdfModal,
      downloadSupportFile,
      downloadModuleFile,
      formatDate
    };
  },
});
</script>

<style scoped>
.pdf-modal-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.pdf-viewer-container {
  height: 80vh;
}

.pdf-viewer-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.modal-dialog-top {
  margin-top: 2rem;
}

.file-name-display {
  font-size: 0.85rem;
  color: #6c757d;
}
</style>